import { render, staticRenderFns } from "./AppointGrid.vue?vue&type=template&id=8dc5a1c8&scoped=true&"
import script from "./AppointGrid.vue?vue&type=script&lang=js&"
export * from "./AppointGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc5a1c8",
  null
  
)

export default component.exports